import { Component, OnDestroy, OnInit } from '@angular/core';
import { InboxControllerService, InboxState, MizenAngularLibService, NotificationDTO } from 'mizen-angular-lib';
import { map, switchMap } from 'rxjs/operators';
import { Subscription, timer } from 'rxjs';
import { CapAlertService } from '../exceptions/cap-alert.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { DatumZeitPipe } from '../../../shared/pipes/simple/datumZeit.pipe';
import { CapAlertLevel } from '../exceptions/cap-alert-level.enum';
import { LAST_POLLING_DATE } from '../login/capi-login-service';

@Component({
  selector: 'cap-mizen-inbox',
  templateUrl: './mizen-inbox.component.html',
  styleUrls: ['./mizen-inbox.component.scss'],
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, TranslatePipe, DatumZeitPipe]
})
export class MizenInboxComponent implements OnInit, OnDestroy {

  public inboxState: InboxState;
  public inboxPath: string;
  public noAttachments: boolean = false;

  private polling$: Subscription;
  private readonly LAST_POLLING_DATE = LAST_POLLING_DATE;
  private readonly message = this.translate.instant('inbox.new-message');

  constructor(
    private inboxControllerService: InboxControllerService,
    private mizenAngularLibService: MizenAngularLibService,
    private capAlertService: CapAlertService,
    private translate: TranslateService
  ) {
    this.polling$ = timer(1, 5000).pipe(
      switchMap(() => {
        return this.inboxControllerService.getInboxState().pipe(
          map(inboxState => this.checkForNewNotifications(inboxState))
        );
      })
    ).subscribe();
    this.inboxPath = this.mizenAngularLibService.getInboxURL();
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.polling$?.unsubscribe();
  }

  getNotificationURL(notification: NotificationDTO): string {
    return this.mizenAngularLibService.getNotificationURL(notification);
  }

  private notShownBefore(unreadNotification, lastPolling): boolean {
    let lastPollingDefined = lastPolling !== undefined && lastPolling !== null;
    let isNewer = new Date(unreadNotification.createDateTime) > new Date(lastPolling);
    return !lastPollingDefined || isNewer;
  }

  private checkForNewNotifications(inboxState: InboxState): void {

    const lastPolling = localStorage.getItem(this.LAST_POLLING_DATE);

    const unread: NotificationDTO[] = inboxState.unreadNotifications.filter(unreadNotification => {
      return unreadNotification.markedAsRead === false && this.notShownBefore(unreadNotification, lastPolling);
    });
    const unreadNonPublic: NotificationDTO[] = unread.filter(dto => dto.publicize === false);

    const hasUnread = unread && unread.length > 0;
    const hasNonPublic = unreadNonPublic && unreadNonPublic.length > 0;

    if (!hasUnread) {
      this.updateInboxState(inboxState);
      return;
    }

    if (hasNonPublic) {
      this.capAlertService.info(this.message, CapAlertLevel.GLOBAL, false, false, this.inboxPath);
    } else {
      this.capAlertService.info(this.message, CapAlertLevel.GLOBAL);
    }
    this.updateInboxState(inboxState);
  }

  private updateInboxState(inboxState: InboxState) {
    this.inboxState = inboxState;
    this.noAttachments = this.inboxState.unreadNotifications.every(unreadNotification => unreadNotification.attachmentList.length <= 0);
    localStorage.setItem(this.LAST_POLLING_DATE, new Date().toJSON());
  }

}
